import api from "@/components/customAxios/Axios";
import { useToast } from "@/components/toast";
import { useLoader } from "@/context/loaderContext";
import { useState } from "react";

import Modal from "react-modal";
import { MdChevronRight } from "react-icons/md";

Modal.setAppElement("#root");

const customStyles = {
	overlay: {
		backgroundColor: "rgba(0, 0, 0, 0)", // fully transparent; change to rgba(0,0,0,0.5) for dim without blur
	},
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		zIndex: 1000,
		borderRadius: "10px",

		width: "100%", // Adjust modal width for responsiveness
		maxWidth: "600px", // Max width for larger screens
		maxHeight: "90vh", // Limit height for smaller screens
	},
};

const CancelSubscription = ({
	setCallfuntionFlag,
}: {
	setCallfuntionFlag: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
	const [modalIsOpen, setIsOpen] = useState(false);
	const { setLoading } = useLoader();
	const toast = useToast();

	const [selectedReason, setSelectedReason] = useState("");
	const [otherReason, setOtherReason] = useState("");

	const reasons = [
		"No longer need a website",
		"Lack of functionality",
		"Too expensive",
		"Found another tool",
		"Purchased accidentally",
		"Other (Please specify)",
	];

	function openModal() {
		setIsOpen(true);
	}

	function closeModal() {
		setIsOpen(false);
	}

	const cancelSubscription = async () => {
		setLoading(true);
		try {
			const response = await api.post(`/cancel_subscription`, {
				feedback:
					selectedReason !== "Other (Please specify)"
						? selectedReason
						: otherReason,
			});
			if (response.status === 200) {
				toast.success({
					type: "background",
					duration: 3000,
					status: "Success",
					title: "Subscription Canceled",
					description: "Your Subscription Is Canceled Sucessfully",
					open: true,
				});
				setCallfuntionFlag((prev) => !prev);
				closeModal();
			}
		} catch (err: any) {
			toast.error({
				type: "background",
				duration: 3000,
				status: "Error",
				title: "Error cancelling subscription",
				description: err.response?.data?.error || err.response?.data?.message || "An error occurred.",
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};

	const handleNext = async () => {
		if (selectedReason === "Other (Please specify)" && !otherReason.trim()) {
			toast.error({
				type: "background",
				duration: 3000,
				status: "Error",
				title: "Please specify the reason",
				description:
					"Please select one of the reason listed below or specify a reason",
				open: true,
			});
			return;
		}
		await cancelSubscription();
	};

	return (
		<div>
			<button
				onClick={openModal}
				className="text-left text-[#438437] font-medium   w-full "
			>
				<div className="flex justify-between items-center   py-3 mx-4  text-[#AF0200]">
					<div>Cancel Subscription</div>
					<div className="flex items-center gap-2  cursor-pointer">
						<MdChevronRight />
					</div>
				</div>
			</button>
			<Modal
				isOpen={modalIsOpen}
				onRequestClose={closeModal}
				style={customStyles}
				contentLabel="Candidate Information Modal"
			>
				<div className="bg-white rounded-2xl p-8  space-y-6 ">
					<h2 className="text-2xl font-semibold">Cancel Plan</h2>
					<p className="text-gray-600 text-sm">
						Thank you for choosing talentick.ai. We’re sorry to see you go.
						Before you cancel, please specify your reason of cancellation below.
					</p>

					<div className="space-y-4">
						{reasons.map((reason) => (
							<div key={reason} className="flex items-center gap-3">
								<input
									type="radio"
									id={reason}
									name="cancelReason"
									value={reason}
									checked={selectedReason === reason}
									onChange={() => setSelectedReason(reason)}
									className="w-4 h-4 text-green-950 bg-green-950"
								/>
								<label
									htmlFor={reason}
									className="text-gray-700 text-sm cursor-pointer"
								>
									{reason}
								</label>
							</div>
						))}

						{selectedReason === "Other (Please specify)" && (
							<textarea
								rows={5}
								placeholder="Reason for cancellation..."
								value={otherReason}
								onChange={(e) => setOtherReason(e.target.value)}
								className="w-full border rounded-lg p-2 text-sm"
							/>
						)}
					</div>

					<div className="mt-6 flex justify-stretch space-x-3">
						<button
							onClick={handleNext}
							className="bg-[#BDE4C3] text-[#438437] px-4 py-2 rounded w-full"
						>
							Submit
						</button>
						<button
							onClick={closeModal}
							className="px-4 py-2 text-[#438437] border-1 rounded-md hover:bg-gray-300 transition w-full"
						>
							Cancel
						</button>
					</div>
				</div>
			</Modal>
		</div>
	);
};

export default CancelSubscription;